import { memo } from "react";

import { InputNumberField } from "@/components/ui/form/fields/input-field/input-number";
import { Label } from "@/components/ui/label/label";

type Props = {
	minimumTransferAmount: number;
	minimumTransferAmountErrorMessage?: string;
	onChangeMinimumTransferAmount: (value: number) => void;
};

export const MinimumTransferAmountForm = memo(
	({ minimumTransferAmount, minimumTransferAmountErrorMessage, onChangeMinimumTransferAmount }: Props) => {
		return (
			<div className="flex w-full flex-col gap-x-6 p-5 md:flex-row">
				<div className="grid w-full max-w-52 flex-none">
					<div className="mt-2">
						<div className="flex items-center gap-2">
							<h5>最低送金金額の設定</h5>
							<Label text="必須" size="sm" />
						</div>
					</div>
				</div>

				<div className="mt-3 w-full md:max-w-md">
					<div className="mt-1">
						<InputNumberField
							label="最低送金金額（円）"
							value={minimumTransferAmount}
							hiddenSpinButton
							handleInput={
								// 全ての入力内容を削除する操作を許容するためにundefinedの入力を許容している
								// undefinedが入力された場合にはZodのバリデーションエラーを表示する
								(value) => onChangeMinimumTransferAmount(value!)
							}
							errorMessage={minimumTransferAmountErrorMessage}
						/>
					</div>
					<div className="mt-2">
						<p className="text-xs text-caption-50">
							※締め日にこの金額以上の売上が貯まっていれば、入金手数料250円を引いた金額が振り込まれます
						</p>
					</div>
				</div>
			</div>
		);
	},
);
